import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Loader } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { Language } from "../../../CorporateProfile/Corporate.hook";
import { toCamelCase } from "../../../CorporateProfile/OurPolicies/OurPoliciesDynamic";
import { toUniqueKey } from "../../../Sustainbility/Community/MainContent/MainContent";
import { CommericialLeasingOppurtunitesPageContent } from "../CommericialLeasingOppurtunitesPageContent";
import { CommericialLeasingOppurtunitesPageHeading } from "../CommericialLeasingOppurtunitesPageHeading";
import { useCommercialLeasingOpportunitesTab } from "./CommercialLeasingOpportunities.hook";
import { fields, fieldsReady } from "./constants";
const formatIndustryValues = (values: string[] = []) => {
  const formatted = values.map((item) => ({
    label: item,
    value: item
      .toLowerCase()
      .trim()
      .replace(/&/g, "and") // optional if you want to keep 'and'
      .replace(/[^a-z0-9\s-]/g, "") // remove special chars except spaces/hyphens
      .replace(/\s+/g, "-") // replace spaces with hyphens
      .replace(/-+/g, "-"), // collapse multiple hyphens into one
  }));
  return [
    ...formatted,
  ];
};
export const CommercialLeasingOpportunitiesTabs: React.FC = (): JSX.Element => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");
  const [fieldData, setFieldData] = useState<any>();

  const [payloadData, setPayloadData] = useState<any>();
  const {
    data: profileData,
    isLoading: isLoadingProfile,
    refetch: refetchOurProfile,
  } = useCommercialLeasingOpportunitesTab();
  const {
    data: profileDataById,
    isLoading: isLoadingprofileById,
    refetch: refetchOurProfileById,
  } = useDocumentDetails(query?.get("id") || "");
  useEffect(() => {
    if (query.get("id")) {
      return;
    }
    if (query.get("activeTab") === "commercialLeasingOpportunities") {
      navigate(
        `/dedicated/corporate/business-oppurtunities?activeTab=commercialLeasingOpportunities&subActiveTab=${
          query.get("subActiveTab") || "commercialLeasingOpportunitiesPageHeading"
        }`,
        {
          replace: true,
        }
      );
    }
  }, [query.get("activeTab"), query.get("subActiveTab")]);
  console.log("profileDataById", profileDataById, profileData);

  useEffect(() => {
    if (query?.get("id")) {
      let parsedEnglish = null;
      try {
        parsedEnglish = profileDataById?.payload?.field_content_english
          ? JSON.parse(profileDataById.payload.field_content_english)
          : { data: { items: [], nextPage: {} } };
      } catch (e) {
        console.error("Error parsing field_content_english:", e);
        parsedEnglish = { data: { items: [], nextPage: {} } };
      }

      let parsedMalay = null;
      try {
        parsedMalay = profileDataById?.payload?.field_content_malay
          ? JSON.parse(profileDataById.payload.field_content_malay)
          : { data: { items: [], nextPage: {} } };
      } catch (e) {
        console.error("Error parsing field_content_malay:", e);
        parsedMalay = { data: { items: [], nextPage: {} } };
      }

      let parsedMandarin = null;
      try {
        parsedMandarin = profileDataById?.payload?.field_content_mandarin
          ? JSON.parse(profileDataById.payload.field_content_mandarin)
          : { data: { items: [], nextPage: {} } };
      } catch (e) {
        console.error("Error parsing field_content_mandarin:", e);
        parsedMandarin = { data: { items: [], nextPage: {} } };
      }

      setPayloadData([
        {
          id: profileDataById?.payload?.id,
          title: profileDataById?.payload?.title,
          field_content_english: parsedEnglish,
          field_content_malay: parsedMalay,
          field_content_mandarin: parsedMandarin,
          field_page: profileDataById?.payload?.field_page,
          published: profileDataById?.payload?.published,
          createdAt: profileDataById?.payload?.createdAt,
          updatedAt: profileDataById?.payload?.updatedAt,
        },
      ]);
    } else {
      setPayloadData(profileData);
    }
  }, [profileData, profileDataById]);

  useEffect(() => {
    if (approveId) {
      refetchOurProfileById();
    } else {
      refetchOurProfile();
    }
  }, [query.get("subActiveTab"), approveId]);

  async function fetchData() {
    await fieldsReady;
    setFieldData(fields);
  }

  useEffect(() => {
    fetchData();
  }, []);
  const createFormConfig = (name?: string, idx1?: any, field?: any): FormConfig => {
    const getMarkupValue = (language: Language) => {
      const payload = profileDataById?.payload?.[language];

      if (!isLoadingprofileById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.items?.[idx1]?.body);
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.items?.[idx1]?.body);
        }
      }

      return decodeHTML(profileData?.[0]?.[language]?.data?.items?.[idx1]?.body);
    };

    const getTabNameValue = (language: Language) => {
      const payload = profileDataById?.payload?.[language];

      if (!isLoadingprofileById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.items?.[idx1]?.tab?.name);
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.items?.[idx1]?.tab?.name);
        }
      }

      return decodeHTML(profileData?.[0]?.[language]?.data?.items?.[idx1]?.tab?.name);
    };

    return {
      initialValues: {
        [`field_content_english.data.items[${idx1}].body`]: getMarkupValue("field_content_english"),
        [`field_content_malay.data.items[${idx1}].body`]: getMarkupValue("field_content_malay"),
        [`field_content_mandarin.data.items[${idx1}].body`]: getMarkupValue("field_content_mandarin"),
        [`field_content_english.data.items[${idx1}].tab.name`]: getTabNameValue("field_content_english"),
        [`field_content_malay.data.items[${idx1}].tab.name`]: getTabNameValue("field_content_malay"),
        [`field_content_mandarin.data.items[${idx1}].tab.name`]: getTabNameValue("field_content_mandarin"),
      },
      fields: field,
    };
  };
  const NextPageFormConfig: FormConfig = {
      initialValues: {
        "field_content_english.data.nextPage.name": (() => {
          try {
            if (profileDataById?.payload?.field_content_english) {
              const parsed = JSON.parse(profileDataById.payload.field_content_english);
              return decodeHTML(parsed?.data?.nextPage?.name);
            }
            return decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.name) || "";
          } catch (error) {
            console.error("Error parsing English nextPage name:", error);
            return decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.name) || "";
          }
        })(),
  
        "field_content_english.data.nextPage.link": (() => {
          try {
            if (profileDataById?.payload?.field_content_english) {
              const parsed = JSON.parse(profileDataById.payload.field_content_english);
              return decodeHTML(parsed?.data?.nextPage?.link);
            }
            return decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.link) || "";
          } catch (error) {
            console.error("Error parsing English nextPage link:", error);
            return decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.link) || "";
          }
        })(),
  
        "field_content_malay.data.nextPage.name": (() => {
          try {
            if (profileDataById?.payload?.field_content_malay) {
              const parsed = JSON.parse(profileDataById.payload.field_content_malay);
              return decodeHTML(parsed?.data?.nextPage?.name);
            }
            return decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.name) || "";
          } catch (error) {
            console.error("Error parsing Malay nextPage name:", error);
            return decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.name) || "";
          }
        })(),
  
        "field_content_malay.data.nextPage.link": (() => {
          try {
            if (profileDataById?.payload?.field_content_malay) {
              const parsed = JSON.parse(profileDataById.payload.field_content_malay);
              return decodeHTML(parsed?.data?.nextPage?.link);
            }
            return decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.link) || "";
          } catch (error) {
            console.error("Error parsing Malay nextPage link:", error);
            return decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.link) || "";
          }
        })(),
  
        "field_content_mandarin.data.nextPage.name": (() => {
          try {
            if (profileDataById?.payload?.field_content_mandarin) {
              const parsed = JSON.parse(profileDataById.payload.field_content_mandarin);
              return decodeHTML(parsed?.data?.nextPage?.name);
            }
            return decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.name) || "";
          } catch (error) {
            console.error("Error parsing Mandarin nextPage name:", error);
            return decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.name) || "";
          }
        })(),
  
        "field_content_mandarin.data.nextPage.link": (() => {
          try {
            if (profileDataById?.payload?.field_content_mandarin) {
              const parsed = JSON.parse(profileDataById.payload.field_content_mandarin);
              return decodeHTML(parsed?.data?.nextPage?.link);
            }
            return decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.link) || "";
          } catch (error) {
            console.error("Error parsing Mandarin nextPage link:", error);
            return decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.link) || "";
          }
        })(),
      },
      fields: fields?.commercialLeasingOpportunitiesNextPage,
    };

  const updatePayload = (data: any) => {
    console.log("Data for... 1", data);
    const convertDotNotation = (obj: any): any => {
      const result: any = {};
      for (const key in obj) {
        if (key.includes(".")) {
          const topLevelKey = key.split(".")[0];
          if (obj[topLevelKey] && typeof obj[topLevelKey] === "object") {
            continue;
          }

          const parts = key.split(".");
          let current = result;

          for (let i = 0; i < parts.length - 1; i++) {
            current[parts[i]] = current[parts[i]] || {};
            current = current[parts[i]];
          }

          current[parts[parts.length - 1]] = obj[key];
        } else {
          result[key] = obj[key];
        }
      }

      return result;
    };

    const filterNestedObjects = (obj: any): any => {
      const result: any = {};

      for (const key in obj) {
        if (typeof obj[key] === "object" && obj[key] !== null) {
          if (Array.isArray(obj[key])) {
            result[key] = obj[key];
          } else {
            result[key] = filterNestedObjects(obj[key]);
          }
        } else {
          result[key] = obj[key];
        }
      }

      return result;
    };

    const replacePayload = (target: any, source: any) => {
      for (const key in source) {
        if (source[key] instanceof Object && target[key]) {
          replacePayload(target[key], source[key]);
        } else {
          target[key] = source[key];
        }
      }
    };

    const convertedData = convertDotNotation(data);
    const filteredData = filterNestedObjects(convertedData);
    console.log("Data for... 2", data, convertedData, filteredData);
    const payload = { ...payloadData[0] };
    replacePayload(payload, filteredData);
    const setIndexFromName = (langField: any) => {
      if (!langField?.data?.items) return;
      langField.data.items = langField.data.items.map((item: any) => {
        if (item?.tab) {
          const name = item.tab.name || "";
          const computedIndex = item.tab.index; //name ? toUniqueKey(name) : item.tab.index;
          return {
            ...item,
            tab: {
              ...item.tab,
              index: computedIndex,
            },
          };
        }
        return item;
      });
    };

    setIndexFromName(payload.field_content_english);
    setIndexFromName(payload.field_content_malay);
    setIndexFromName(payload.field_content_mandarin);
    console.log("Data for... 3", data, payload);
    if (payload.field_content_english) {
      payload.field_content_english = JSON.stringify(payload.field_content_english);
    }
    if (payload.field_content_malay) {
      payload.field_content_malay = JSON.stringify(payload.field_content_malay);
    }
    if (payload.field_content_mandarin) {
      payload.field_content_mandarin = JSON.stringify(payload.field_content_mandarin);
    }
    return payload;
  };
  const mainContentUpdatePayload = (data: any) => {
    return {
      id: profileDataById?.payload?.id || profileData?.[0]?.id,
      field_content_english: JSON.stringify({
        data: {
          ...(profileDataById?.payload?.field_content_english 
            ? JSON.parse(profileDataById.payload.field_content_english)?.data 
            : profileData?.[0]?.field_content_english?.data || {}),
          markup: data["field_content_english_markup"] ?? "",
          inquiriesMarkup: data["field_content_english_inquiriesMarkup"] ?? "",
          addressMarkup: data["field_content_english_addressMarkup"] ?? "",
          map:{
            coordinates: {
              lat: data["field_content_english_map_coordinates_lat"] ?? "",
              lng: data["field_content_english_map_coordinates_lng"] ?? ""
            }
          },
          afterSubmitText: {
            thankYouText: data["field_content_english_afterSubmitText_thankYouText"] ?? "",
            backToFrom: data["field_content_english_afterSubmitText_backToFrom"] ?? ""
          }
        }
      }),
      field_content_malay: JSON.stringify({
        data: {
          ...(profileDataById?.payload?.field_content_malay 
            ? JSON.parse(profileDataById.payload.field_content_malay)?.data 
            : profileData?.[0]?.field_content_malay?.data || {}),
          markup: data["field_content_malay_markup"] ?? "",
          inquiriesMarkup: data["field_content_malay_inquiriesMarkup"] ?? "",
          addressMarkup: data["field_content_malay_addressMarkup"] ?? "",
          map:{
            coordinates: {
              lat: data["field_content_malay_map.coordinates_lat"] ?? "",
              lng: data["field_content_malay_map.coordinates_lng"] ?? ""
            }
          },
          afterSubmitText: {
            thankYouText: data["field_content_malay_afterSubmitText_thankYouText"] ?? "",
            backToFrom: data["field_content_malay_afterSubmitText_backToFrom"] ?? ""
          }
        }
      }),
      field_content_mandarin: JSON.stringify({
        data: {
          ...(profileDataById?.payload?.field_content_mandarin 
            ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data 
            : profileData?.[0]?.field_content_mandarin?.data || {}),
          markup: data["field_content_mandarin_markup"] ?? "",
          inquiriesMarkup: data["field_content_mandarin_inquiriesMarkup"] ?? "",
          addressMarkup: data["field_content_mandarin_addressMarkup"] ?? "",
          map:{
            coordinates: {
              lat: data["field_content_mandarin_map.coordinates_lat"] ?? "",
              lng: data["field_content_mandarin_map.coordinates_lng"] ?? ""
            }
          },
          afterSubmitText: {
            thankYouText: data["field_content_mandarin_afterSubmitText_thankYouText"] ?? "",
            backToFrom: data["field_content_mandarin_afterSubmitText_backToFrom"] ?? ""
          }
        }
      }),
      field_page: profileDataById?.payload?.field_page || profileData?.[0]?.field_page || "",
      published: true
    };
  }
  const formValuesUpdatePayload = (data: any) => {
    return {
      id: profileDataById?.payload?.id || profileData?.[0]?.id,
      field_content_english: JSON.stringify({
        data: {
          ...(profileDataById?.payload?.field_content_english 
            ? JSON.parse(profileDataById.payload.field_content_english)?.data 
            : profileData?.[0]?.field_content_english?.data || {}),
          form: {
            labels: {
              nameText: data["field_content_english_form_labels_nameText"] ?? "",
              natureOfEnquiryText: data["field_content_english_form_labels_natureOfEnquiryText"] ?? "",
              companyText: data["field_content_english_form_labels_companyText"] ?? "",
              industryText: data["field_content_english_form_labels_industryText"] ?? "",
              emailText: data["field_content_english_form_labels_emailText"] ?? "",
              subjectText: data["field_content_english_form_labels_subjectText"] ?? "",
              messageText: data["field_content_english_form_labels_messageText"] ?? "",
              captcha: {
                titleText: data["field_content_english_form_labels_captcha_titleText"] ?? "",
                helpText: data["field_content_english_form_labels_captcha_helpText"] ?? "",
                newCaptchaText: data["field_content_english_form_labels_captcha_newCaptchaText"] ?? ""
              },
              submitButtonText: data["field_content_english_form_labels_submitButtonText"] ?? ""
            },
            values: {
              industryValue: formatIndustryValues(data["field_content_english_form_values_industryValue"]) || [],
              natureOfEnquiryValue: formatIndustryValues(data["field_content_english_form_values_natureOfEnquiryValue"]) || []
            },
          },
        }
      }),
      field_content_malay: JSON.stringify({
        data: {
          ...(profileDataById?.payload?.field_content_malay 
            ? JSON.parse(profileDataById.payload.field_content_malay)?.data 
            : profileData?.[0]?.field_content_malay?.data || {}),
          form: {
            labels: {
              nameText: data["field_content_malay_form_labels_nameText"] ?? "",
              natureOfEnquiryText: data["field_content_malay_form_labels_natureOfEnquiryText"] ?? "",
              companyText: data["field_content_malay_form_labels_companyText"] ?? "",
              industryText: data["field_content_malay_form_labels_industryText"] ?? "",
              emailText: data["field_content_malay_form_labels_emailText"] ?? "",
              subjectText: data["field_content_malay_form_labels_subjectText"] ?? "",
              messageText: data["field_content_malay_form_labels_messageText"] ?? "",
              captcha: {
                titleText: data["field_content_malay_form_labels_captcha_titleText"] ?? "",
                helpText: data["field_content_malay_form_labels_captcha_helpText"] ?? "",
                newCaptchaText: data["field_content_malay_form_labels_captcha_newCaptchaText"] ?? ""
              },
              submitButtonText: data["field_content_malay_form_labels_submitButtonText"] ?? ""
            },
            values: {
              industryValue: formatIndustryValues(data["field_content_malay_form_values_industryValue"]) || [],
              natureOfEnquiryValue: formatIndustryValues(data["field_content_malay_form_values_natureOfEnquiryValue"]) || []
            },
          },
        }
      }),
      field_content_mandarin: JSON.stringify({
        data: {
          ...(profileDataById?.payload?.field_content_mandarin 
            ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data 
            : profileData?.[0]?.field_content_mandarin?.data || {}),
          form: {
            labels: {
              nameText: data["field_content_mandarin_form_labels_nameText"] ?? "",
              natureOfEnquiryText: data["field_content_mandarin_form_labels_natureOfEnquiryText"] ?? "",
              companyText: data["field_content_mandarin_form_labels_companyText"] ?? "",
              industryText: data["field_content_mandarin_form_labels_industryText"] ?? "",
              emailText: data["field_content_mandarin_form_labels_emailText"] ?? "",
              subjectText: data["field_content_mandarin_form_labels_subjectText"] ?? "",
              messageText: data["field_content_mandarin_form_labels_messageText"] ?? "",
              captcha: {
                titleText: data["field_content_mandarin_form_labels_captcha_titleText"] ?? "",
                helpText: data["field_content_mandarin_form_labels_captcha_helpText"] ?? "",
                newCaptchaText: data["field_content_mandarin_form_labels_captcha_newCaptchaText"] ?? ""
              },
              submitButtonText: data["field_content_mandarin_form_labels_submitButtonText"] ?? ""
            },
            values: {
              industryValue: formatIndustryValues(data["field_content_mandarin_form_values_industryValue"]) || [],
              natureOfEnquiryValue: formatIndustryValues(data["field_content_mandarin_form_values_natureOfEnquiryValue"]) || []
            },
          },
        }
      }),
      field_page: profileDataById?.payload?.field_page || profileData?.[0]?.field_page || "",
      published: true
    };
  }

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    const subActiveTab = query.get("subActiveTab");
    let idx1: number | undefined;
    let payloadData;
    if(subActiveTab === "commercialLeasingOpportunitiesMainContent") {
      payloadData = await mainContentUpdatePayload(data);
    } else if(subActiveTab === "commercialLeasingOpportunitiesFormValues") {
      payloadData = await formValuesUpdatePayload(data);
    } else {
      payloadData = await updatePayload(data);
    }
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
    ];

    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field && field[0]) {
          if (field[0].originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", field[0].originFileObj);
            formData.append("application", "CORPORATE");
            const res: any = await post("management/upload-file", formData);

            if (res) {
              data[key] = res.response.data;
            }
          } else if (field[0].url) {
            data[key] = field[0].url;
          }
        }
      } catch (error) {}
    }
    let payload;
    if (query.get("activeTab") === "commercialLeasingOpportunities") {
      const activeTab = query?.get("activeTab") || "commercialLeasingOpportunities";
      let computedSubModule = `${activeTab}_${subActiveTab || ""}`;
      if (subActiveTab && subActiveTab !== "nextPage" && subActiveTab !== 'commercialLeasingOpportunitiesMainContent' && subActiveTab !== "commercialLeasingOpportunitiesFormValues") {
        try {
          const match = subActiveTab.match(/ForCommercialLeasingOpportunities_(\d+)$/);
          idx1 = match ? parseInt(match[1], 10) : undefined;
          const englishJson = payloadData?.field_content_english
            ? JSON.parse(payloadData.field_content_english)
            : undefined;
          const currentIndex = englishJson?.data?.items?.[idx1 || 0]?.tab?.index;
          if (currentIndex) {
            computedSubModule = `${activeTab}_${toCamelCase(currentIndex)}ForCommercialLeasingOpportunities_${idx1}`;
          }
        } catch (e) {
          computedSubModule = `${activeTab}_${subActiveTab}`;
        }
      }
      payload = {
        action: action,
        method: method,
        module: "Business Opportunities",
        subModule: computedSubModule,
        type: "DEDICATED",
        application: "MAHB_CORPORATE",
        moduleKey: "MAHB_CORPORATE_Business Opportunities_Commercial Leasing Opportunities",
        reviewNotes: reviewNotes,
        appList: [
          {
            appName: "MAHB_CORPORATE",
            apiUrl: apiUrl,
          },
        ],
        payload: payloadData,
        status: status,
      };
    }

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  const generateFormItem = (label: any, key: any, config: any, API_ENDPOINT: any) => ({
    label,
    key,
    children: (
      <DynamicForm
        isLoading={isLoadingProfile || isLoadingprofileById}
        config={config}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(data, API_ENDPOINT, "UPDATE", "PATCH", buttonValue === "save" ? "DRAFT" : "PENDING", reviewNotes)
        }
        defaultReviewNotes="Kindly review this Business Opportunities"
      />
    ),
  });

  const profileChildItems = profileData
    ? profileData?.[0]?.field_content_english?.data?.items.filter(Boolean).map((item: any, index: any) => {
        const uniqueKey = `${toCamelCase(item.tab.index)}ForCommercialLeasingOpportunities_${index}`;
        console.log("profileChildItems", item, uniqueKey);
        return generateFormItem(
          item.tab.name,
          uniqueKey,
          createFormConfig(item.tab.index, [index], fieldData?.commercialLeasingOpportunities?.[index]),
          `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || "64"}`
        );
      })
    : (() => {
        const fieldContent = profileDataById?.payload?.field_content_english;
        let parsedContent;
        console.log("fieldContent", fieldContent);
        // Validate and safely parse JSON
        try {
          parsedContent = fieldContent ? JSON.parse(fieldContent) : null;
        } catch (error) {
          console.error("Failed to parse field_content_english:", error);
          parsedContent = null;
        }
        console.log("parsedContent", parsedContent);
        return (
          parsedContent?.data?.items?.filter(Boolean)?.map((item: any, index: any) => {
            const uniqueKey = `${toCamelCase(item?.tab?.index)}ForCommercialLeasingOpportunities_${index}`;
            console.log("profileChildItems", item, uniqueKey);
            return generateFormItem(
              item?.tab?.name,
              uniqueKey,
              createFormConfig(item?.tab?.index, [index], fieldData?.commercialLeasingOpportunities?.[index]),
              `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || "64"}`
            );
          }) || []
        );
      })();
  // profileChildItems.push(
  //   generateFormItem(
  //     "Next Page",
  //     "nextPage",
  //     NextPageFormConfig,
  //     `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || "64"}`
  //   )
  // );  
  profileChildItems.unshift({
    label: "Main Content",
    key: "commercialLeasingOpportunitiesMainContent",
    children: (
      <DynamicForm
        isLoading={isLoadingProfile || isLoadingprofileById}
        config={{
          initialValues: {
            "field_content_english_markup": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.markup || ""
              : profileData?.[0]?.field_content_english?.data?.markup || "",
            "field_content_malay_markup": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.markup || ""
              : profileData?.[0]?.field_content_malay?.data?.markup || "",
            "field_content_mandarin_markup": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.markup || ""
              : profileData?.[0]?.field_content_mandarin?.data?.markup || "",

            "field_content_english_inquiriesMarkup": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.inquiriesMarkup || ""
              : profileData?.[0]?.field_content_english?.data?.inquiriesMarkup || "",
            "field_content_malay_inquiriesMarkup": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.inquiriesMarkup || ""
              : profileData?.[0]?.field_content_malay?.data?.inquiriesMarkup || "",
            "field_content_mandarin_inquiriesMarkup": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.inquiriesMarkup || ""
              : profileData?.[0]?.field_content_mandarin?.data?.inquiriesMarkup || "",

            "field_content_english_addressMarkup": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.addressMarkup || ""
              : profileData?.[0]?.field_content_english?.data?.addressMarkup || "",
            "field_content_malay_addressMarkup": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.addressMarkup || ""
              : profileData?.[0]?.field_content_malay?.data?.addressMarkup || "",
            "field_content_mandarin_addressMarkup": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.addressMarkup || ""
              : profileData?.[0]?.field_content_mandarin?.data?.addressMarkup || "",

            "field_content_english_map_coordinates_lat": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.map?.coordinates?.lat || ""
              : profileData?.[0]?.field_content_english?.data?.map?.coordinates?.lat || "",
            "field_content_malay_map_coordinates_lat": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.map?.coordinates?.lat || ""
              : profileData?.[0]?.field_content_malay?.data?.map?.coordinates?.lat || "",
            "field_content_mandarin_map_coordinates_lat": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.map?.coordinates?.lat || ""
              : profileData?.[0]?.field_content_mandarin?.data?.map?.coordinates?.lat || "",

            "field_content_english_map_coordinates_lng": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.map?.coordinates?.lng || ""
              : profileData?.[0]?.field_content_english?.data?.map?.coordinates?.lng || "",
            "field_content_malay_map_coordinates_lng": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.map?.coordinates?.lng || ""
              : profileData?.[0]?.field_content_malay?.data?.map?.coordinates?.lng || "",
            "field_content_mandarin_map_coordinates_lng": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.map?.coordinates?.lng || ""
              : profileData?.[0]?.field_content_mandarin?.data?.map?.coordinates?.lng || "",
            
            "field_content_english_afterSubmitText_backToFrom": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.afterSubmitText?.backToFrom || ""
              : profileData?.[0]?.field_content_english?.data?.afterSubmitText?.backToFrom || "",
            "field_content_malay_afterSubmitText_backToFrom": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.afterSubmitText?.backToFrom || ""
              : profileData?.[0]?.field_content_malay?.data?.afterSubmitText?.backToFrom || "",
            "field_content_mandarin_afterSubmitText_backToFrom": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.afterSubmitText?.backToFrom || ""
              : profileData?.[0]?.field_content_mandarin?.data?.afterSubmitText?.backToFrom || "",
            
            "field_content_english_afterSubmitText_thankYouText": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.afterSubmitText?.thankYouText || ""
              : profileData?.[0]?.field_content_english?.data?.afterSubmitText?.thankYouText || "",
            "field_content_malay_afterSubmitText_thankYouText": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.afterSubmitText?.thankYouText || ""
              : profileData?.[0]?.field_content_malay?.data?.afterSubmitText?.thankYouText || "",
            "field_content_mandarin_afterSubmitText_thankYouText": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.afterSubmitText?.thankYouText || ""
              : profileData?.[0]?.field_content_mandarin?.data?.afterSubmitText?.thankYouText || "",
          },
          fields: fieldData?.commercialLeasingOpportunitiesMainContent || [],
        }}
        onSubmit={(data, buttonValue, reviewNotes) => {
          return onSubmit(
            data,
            `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || "64"}`,
            "UPDATE",
            "PATCH",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          );
        }}
        defaultReviewNotes="Kindly review this Business Opportunities"
      />
    ),
  });
  profileChildItems.unshift({
    label: "Form Values",
    key: "commercialLeasingOpportunitiesFormValues",
    children: (
      <DynamicForm
        isLoading={isLoadingProfile || isLoadingprofileById}
        config={{
          initialValues: {
            "field_content_english_form_labels_nameText": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.form?.labels?.nameText || ""
              : profileData?.[0]?.field_content_english?.data?.form?.labels?.nameText || "",
            "field_content_malay_form_labels_nameText": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.form?.labels?.nameText || ""
              : profileData?.[0]?.field_content_malay?.data?.form?.labels?.nameText || "",
            "field_content_mandarin_form_labels_nameText": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.form?.labels?.nameText || ""
              : profileData?.[0]?.field_content_mandarin?.data?.form?.labels?.nameText || "",

            "field_content_english_form_labels_natureOfEnquiryText": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.form?.labels?.natureOfEnquiryText || ""
              : profileData?.[0]?.field_content_english?.data?.form?.labels?.natureOfEnquiryText || "",
            "field_content_malay_form_labels_natureOfEnquiryText": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.form?.labels?.natureOfEnquiryText || ""
              : profileData?.[0]?.field_content_malay?.data?.form?.labels?.natureOfEnquiryText || "",
            "field_content_mandarin_form_labels_natureOfEnquiryText": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.form?.labels?.natureOfEnquiryText || ""
              : profileData?.[0]?.field_content_mandarin?.data?.form?.labels?.natureOfEnquiryText || "",

            "field_content_english_form_labels_companyText": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.form?.labels?.companyText || ""
              : profileData?.[0]?.field_content_english?.data?.form?.labels?.companyText || "",
            "field_content_malay_form_labels_companyText": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.form?.labels?.companyText || ""
              : profileData?.[0]?.field_content_malay?.data?.form?.labels?.companyText || "",
            "field_content_mandarin_form_labels_companyText": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.form?.labels?.companyText || ""
              : profileData?.[0]?.field_content_mandarin?.data?.form?.labels?.companyText || "",

            "field_content_english_form_labels_industryText": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.form?.labels?.industryText || ""
              : profileData?.[0]?.field_content_english?.data?.form?.labels?.industryText || "",
            "field_content_malay_form_labels_industryText": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.form?.labels?.industryText || ""
              : profileData?.[0]?.field_content_malay?.data?.form?.labels?.industryText || "",
            "field_content_mandarin_form_labels_industryText": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.form?.labels?.industryText || ""
              : profileData?.[0]?.field_content_mandarin?.data?.form?.labels?.industryText || "",

            "field_content_english_form_labels_emailText": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.form?.labels?.emailText || ""
              : profileData?.[0]?.field_content_english?.data?.form?.labels?.emailText || "",
            "field_content_malay_form_labels_emailText": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.form?.labels?.emailText || ""
              : profileData?.[0]?.field_content_malay?.data?.form?.labels?.emailText || "",
            "field_content_mandarin_form_labels_emailText": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.form?.labels?.emailText || ""
              : profileData?.[0]?.field_content_mandarin?.data?.form?.labels?.emailText || "",
            
            "field_content_english_form_labels_subjectText": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.form?.labels?.subjectText || ""
              : profileData?.[0]?.field_content_english?.data?.form?.labels?.subjectText || "",
            "field_content_malay_form_labels_subjectText": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.form?.labels?.subjectText || ""
              : profileData?.[0]?.field_content_malay?.data?.form?.labels?.subjectText || "",
            "field_content_mandarin_form_labels_subjectText": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.form?.labels?.subjectText || ""
              : profileData?.[0]?.field_content_mandarin?.data?.form?.labels?.subjectText || "",
            
            "field_content_english_form_labels_messageText": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.form?.labels?.messageText || ""
              : profileData?.[0]?.field_content_english?.data?.form?.labels?.messageText || "",
            "field_content_malay_form_labels_messageText": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.form?.labels?.messageText || ""
              : profileData?.[0]?.field_content_malay?.data?.form?.labels?.messageText || "",
            "field_content_mandarin_form_labels_messageText": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.form?.labels?.messageText || ""
              : profileData?.[0]?.field_content_mandarin?.data?.form?.labels?.messageText || "",

            "field_content_english_form_labels_submitButtonText": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.form?.labels?.submitButtonText || ""
              : profileData?.[0]?.field_content_english?.data?.form?.labels?.submitButtonText || "",
            "field_content_malay_form_labels_submitButtonText": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.form?.labels?.submitButtonText || ""
              : profileData?.[0]?.field_content_malay?.data?.form?.labels?.submitButtonText || "",
            "field_content_mandarin_form_labels_submitButtonText": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.form?.labels?.submitButtonText || ""
              : profileData?.[0]?.field_content_mandarin?.data?.form?.labels?.submitButtonText || "",
            
            "field_content_english_form_labels_captcha_titleText": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.form?.labels?.captcha?.titleText || ""
              : profileData?.[0]?.field_content_english?.data?.form?.labels?.captcha?.titleText || "",
            "field_content_malay_form_labels_captcha_titleText": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.form?.labels?.captcha?.titleText || ""
              : profileData?.[0]?.field_content_malay?.data?.form?.labels?.captcha?.titleText || "",
            "field_content_mandarin_form_labels_captcha_titleText": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.form?.labels?.captcha?.titleText || ""
              : profileData?.[0]?.field_content_mandarin?.data?.form?.labels?.captcha?.titleText || "",

            "field_content_english_form_labels_captcha_helpText": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.form?.labels?.captcha?.helpText || ""
              : profileData?.[0]?.field_content_english?.data?.form?.labels?.captcha?.helpText || "",
            "field_content_malay_form_labels_captcha_helpText": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.form?.labels?.captcha?.helpText || ""
              : profileData?.[0]?.field_content_malay?.data?.form?.labels?.captcha?.helpText || "",
            "field_content_mandarin_form_labels_captcha_helpText": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.form?.labels?.captcha?.helpText || ""
              : profileData?.[0]?.field_content_mandarin?.data?.form?.labels?.captcha?.helpText || "",

            "field_content_english_form_labels_captcha_newCaptchaText": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.form?.labels?.captcha?.newCaptchaText || ""
              : profileData?.[0]?.field_content_english?.data?.form?.labels?.captcha?.newCaptchaText || "",
            "field_content_malay_form_labels_captcha_newCaptchaText": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.form?.labels?.captcha?.newCaptchaText || ""
              : profileData?.[0]?.field_content_malay?.data?.form?.labels?.captcha?.newCaptchaText || "",
            "field_content_mandarin_form_labels_captcha_newCaptchaText": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.form?.labels?.captcha?.newCaptchaText || ""
              : profileData?.[0]?.field_content_mandarin?.data?.form?.labels?.captcha?.newCaptchaText || "",

            "field_content_english_form_values_industryValue": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.form?.values?.industryValue?.map((val: any)=> val?.label ) || []
              : profileData?.[0]?.field_content_english?.data?.form?.values?.industryValue?.map((val: any)=> val?.label ) || [],
            "field_content_malay_form_values_industryValue": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.form?.values?.industryValue?.map((val: any)=> val?.label ) || []
              : profileData?.[0]?.field_content_malay?.data?.form?.values?.industryValue?.map((val: any)=> val?.label ) || [],
            "field_content_mandarin_form_values_industryValue": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.form?.values?.industryValue?.map((val: any)=> val?.label ) || []
              : profileData?.[0]?.field_content_mandarin?.data?.form?.values?.industryValue?.map((val: any)=> val?.label ) || [],

            "field_content_english_form_values_natureOfEnquiryValue": profileDataById?.payload?.field_content_english
              ? JSON.parse(profileDataById.payload.field_content_english)?.data?.form?.values?.natureOfEnquiryValue?.map((val: any)=> val?.label ) || []
              : profileData?.[0]?.field_content_english?.data?.form?.values?.natureOfEnquiryValue?.map((val: any)=> val?.label ) || [],
            "field_content_malay_form_values_natureOfEnquiryValue": profileDataById?.payload?.field_content_malay
              ? JSON.parse(profileDataById.payload.field_content_malay)?.data?.form?.values?.natureOfEnquiryValue?.map((val: any)=> val?.label ) || []
              : profileData?.[0]?.field_content_malay?.data?.form?.values?.natureOfEnquiryValue?.map((val: any)=> val?.label ) || [],
            "field_content_mandarin_form_values_natureOfEnquiryValue": profileDataById?.payload?.field_content_mandarin
              ? JSON.parse(profileDataById.payload.field_content_mandarin)?.data?.form?.values?.natureOfEnquiryValue?.map((val: any)=> val?.label ) || []
              : profileData?.[0]?.field_content_mandarin?.data?.form?.values?.natureOfEnquiryValue?.map((val: any)=> val?.label ) || []
          },
          fields: fieldData?.commercialLeasingOpportunitiesFormValues || [],
        }}
        onSubmit={(data, buttonValue, reviewNotes) => {
          return onSubmit(
            data,
            `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || "64"}`,
            "UPDATE",
            "PATCH",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          );
        }}
        defaultReviewNotes="Kindly review this Business Opportunities"
      />
    ),
  });

  // profileChildItems.push({
  //   label: "Page Content",
  //   key: "commericialLeasingOppurtunitiesPageContent",
  //   children: <CommericialLeasingOppurtunitesPageContent />,
  // });
  profileChildItems.unshift({
    label: "Page Heading",
    key: "commercialLeasingOpportunitiesPageHeading",
    children: <CommericialLeasingOppurtunitesPageHeading />,
  });
  if (isLoadingprofileById || isLoadingProfile) {
    return <Loader />;
  }

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={profileChildItems}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=commercialLeasingOpportunities&subActiveTab=${activeKey}`);
        }}
      ></Tabs>
    </>
  );
};
